import type { RoseRocketInvoice, SheetRow } from '../types/entities';
import { withSyncFields } from './helpers';

export async function mapInvoice(invoice: RoseRocketInvoice): Promise<SheetRow> {
  return withSyncFields({
    rr_invoice_id: invoice.id,
    invoice_number: invoice.invoice_number,
    rr_order_id: invoice.order_id || '',
    order_number: invoice.order_number || '',
    customer_name: invoice.customer_name,
    status: invoice.status,
    amount: invoice.amount,
    currency: invoice.currency,
    issued_date: invoice.issued_date || '',
    due_date: invoice.due_date || '',
    rr_created_at: invoice.created_at || '',
    rr_updated_at: invoice.updated_at,
  });
}
